var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcProgramming = function SvgIcProgramming(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3474_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0717 11.7608L24.7932 10.7747L18.9228 36.2428L23.2012 37.229L29.0717 11.7608Z",
    fill: "#FF5347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5178 12.4139L4.49121 21.4436L7.59758 24.5489L16.6241 15.5192L13.5178 12.4139Z",
    fill: "#07F184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49254 21.4442L1.38672 24.55L4.49254 27.6559L7.59837 24.55L4.49254 21.4442Z",
    fill: "#00BF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5963 24.5499L4.49048 27.6558L13.5186 36.6839L16.6244 33.5781L7.5963 24.5499Z",
    fill: "#28DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4841 12.4201L31.3777 15.5254L40.4042 24.5551L43.5106 21.4498L34.4841 12.4201Z",
    fill: "#049DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5101 21.4442L40.4043 24.55L43.5101 27.6559L46.6159 24.55L43.5101 21.4442Z",
    fill: "#004C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4041 24.552L31.376 33.5801L34.4818 36.6859L43.5099 27.6578L40.4041 24.552Z",
    fill: "#7161DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4503 37.6211L29.469 11.5098L24.5474 10.3753L18.5287 36.4867L23.4503 37.6211Z",
    fill: "#FF5347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0899 15.5207L8.06273 24.5495L7.59578 24.0826L4.49048 20.9789L13.5176 11.9485L17.0899 15.5207Z",
    fill: "#07F184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06277 24.5494L7.59582 25.0163L4.49052 28.1216L4.02522 27.6547L0.919922 24.5494L4.02522 21.4441L4.49052 20.9788L7.59582 24.0824L8.06277 24.5494Z",
    fill: "#00BF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0899 33.5784L13.5176 37.1506L4.49048 28.1218L7.59578 25.0165L8.06273 24.5496L17.0899 33.5784Z",
    fill: "#28DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5096 20.9789L40.4043 24.0826L39.9373 24.5495L30.9102 15.5207L34.4824 11.9485L43.5096 20.9789Z",
    fill: "#049DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0801 24.5494L43.9748 27.6547L43.5095 28.1216L40.4042 25.0163L39.9373 24.5494L40.4042 24.0824L43.5095 20.9788L43.9748 21.4441L47.0801 24.5494Z",
    fill: "#004C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5096 28.1218L34.4824 37.1506L30.9102 33.5784L39.9373 24.5496L40.4043 25.0165L43.5096 28.1218Z",
    fill: "#7161DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3474_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcProgramming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ic-programming.0aa62421d30e227ed09dbfea9c76cb70.svg";